import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormGroup, ControlLabel, Modal, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import Loader from '../../../../../../components/Loaders/Loader';
import SelectVirtualized from '../../../../../../components/Select/Virtualized';

import { openModal } from '../../../reducer';
import { MODALS } from '../../../constants';

const ModalMassAssignCategory = ({ serviceDispatch, onClose }) => {
  const { categories } = useSelector((state) => state.services);
  const [category, setCategory] = useState(null);
  const [form] = useState({
    isLoading: false,
    error: null,
    success: false,
  });

  const { isLoading, success } = form;

  const onSubmit = async (e) => {
    e.preventDefault();
    onClose();
    serviceDispatch(openModal(MODALS.ASSIGN_CATEGORY_CONFIRM, { category }));
  };

  return (
    <form onSubmit={onSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>Assign category</Modal.Title>
      </Modal.Header>
      <>
        <Modal.Body>
          {isLoading ? <Loader success={success} /> : null}
          <FormGroup>
            <ControlLabel>Categories</ControlLabel>
            <SelectVirtualized
              name="category"
              components={{ IndicatorSeparator: null }}
              onChange={(value) => setCategory(value)}
              noOptionsMessage={() => 'Not found categories'}
              hideSelectedOptions={false}
              value={category}
              options={categories.map((provider) => ({
                label: provider.title,
                value: provider.id,
              }))}
              placeholder="Choose category"
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          <Button type="submit" bsStyle="primary" disabled={isLoading || isEmpty(category)}>
            Save changes
          </Button>
          <Button disabled={isLoading} onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </>
    </form>
  );
};

ModalMassAssignCategory.propTypes = {
  serviceDispatch: PropTypes.func,
  onClose: PropTypes.func,
};

export default ModalMassAssignCategory;
